import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography, Button, Grid, TextField } from '@mui/material';
import { DataGrid, type GridColDef } from '@mui/x-data-grid';
import CalculateIcon from '@mui/icons-material/Calculate';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { useComisionStore } from '../store/comisionStore';

export const ComisionesPage: React.FC = () => {
  const { comisiones, loading, fetchComisiones, calcularComisiones } = useComisionStore();
  const [fechaDesde, setFechaDesde] = useState('');
  const [fechaHasta, setFechaHasta] = useState('');

  useEffect(() => { fetchComisiones(); }, [fetchComisiones]);

  const handleCalcular = async () => {
    try {
      await calcularComisiones(fechaDesde || undefined, fechaHasta || undefined);
    } catch { /* handled */ }
  };

  const columns: GridColDef[] = [
    { field: 'vendedor', headerName: 'Vendedor', flex: 1, minWidth: 200, valueGetter: (value: any) => value?.usuario || '-' },
    { field: 'montoVenta', headerName: 'Monto Venta', width: 130, type: 'number', valueFormatter: (value: number) => `S/ ${(value ?? 0).toFixed(2)}` },
    { field: 'porcentajeComision', headerName: '% Comision', width: 110, type: 'number', valueFormatter: (value: number) => `${(value ?? 0).toFixed(2)}%` },
    { field: 'montoComision', headerName: 'Monto Comision', width: 140, type: 'number', valueFormatter: (value: number) => `S/ ${(value ?? 0).toFixed(2)}` },
    { field: 'fechaCalculo', headerName: 'Fecha Calculo', width: 130,
      valueFormatter: (value: string) => { try { return format(new Date(value), 'dd/MM/yyyy', { locale: es }); } catch { return value; } } },
    { field: 'estado', headerName: 'Estado', width: 100 },
  ];

  const totalComisiones = comisiones.reduce((sum, c) => sum + (c.montoComision || 0), 0);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" fontWeight="bold" sx={{ mb: 3 }}>Comisiones de Vendedores</Typography>

      <Paper sx={{ p: 2, mb: 2 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid size={{ xs: 12, sm: 4, md: 3 }}>
            <TextField label="Fecha Desde" size="small" fullWidth type="date" InputLabelProps={{ shrink: true }} value={fechaDesde} onChange={(e) => setFechaDesde(e.target.value)} />
          </Grid>
          <Grid size={{ xs: 12, sm: 4, md: 3 }}>
            <TextField label="Fecha Hasta" size="small" fullWidth type="date" InputLabelProps={{ shrink: true }} value={fechaHasta} onChange={(e) => setFechaHasta(e.target.value)} />
          </Grid>
          <Grid size={{ xs: 12, sm: 4, md: 3 }}>
            <Button variant="contained" startIcon={<CalculateIcon />} onClick={handleCalcular} disabled={loading}>
              Calcular Comisiones
            </Button>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 3 }}>
            <Paper sx={{ p: 1.5, bgcolor: 'primary.50', textAlign: 'center' }}>
              <Typography variant="body2" color="text.secondary">Total Comisiones</Typography>
              <Typography variant="h6" color="primary">S/ {totalComisiones.toFixed(2)}</Typography>
            </Paper>
          </Grid>
        </Grid>
      </Paper>

      <Paper sx={{ height: 500 }}>
        <DataGrid rows={comisiones} columns={columns} getRowId={(row) => row.idComisionVendedor} loading={loading}
          pageSizeOptions={[10, 20, 50]} initialState={{ pagination: { paginationModel: { pageSize: 20 } } }}
          sx={{ border: 'none' }} disableRowSelectionOnClick />
      </Paper>
    </Box>
  );
};
